/* global Blockly */
import React from 'react';
import PropTypes from 'prop-types';
import { externalDataIcon } from './index';


function defineBlock(context) {
    return {
        columnNames: [['- select -', 'ColName']],

        init: function () {
            let selectExternalDataDropdown = new Blockly.FieldWidgetsDropdown(context, 'dynamicdropdown', undefined, '- select -', this.updateColumns.bind(this));

            this.appendDummyInput('WIDGET')
                .appendField('get')
                .appendField(new Blockly.FieldImage(externalDataIcon, 30, 30, "externalData icon", null), 'externalDataIcon')
                .appendField(selectExternalDataDropdown, 'ID')
                .appendField('column')
                .appendField(new Blockly.FieldDropdown(this.columnNames), 'COLUMN');
             
            this.appendDummyInput('ASSTRING')
                .appendField('as')
                .appendField(new Blockly.FieldDropdown([['string', 'true'], ['list', 'false']]), 'ASSTRING');

            this.setPreviousStatement(false);
            this.setNextStatement(false);
            this.setOutput(true, "Array");
            this.setOutputShape(Blockly.OUTPUT_SHAPE_ROUND);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Return the specified column in a External Data widget.');
            this.setHelpUrl(`${Blockly.BASE_HELP_URL}#external-data`);
        },

        updateColumns: function (selectedExternalDataDropdownId) {
            if (selectedExternalDataDropdownId === '- select -') return;
            
            context.pages.forEach(page => {
                let externalDataDropdown = page.widgets.find(widget => widget.id == selectedExternalDataDropdownId);

                if (externalDataDropdown) {
                    let widget = this.getInput("WIDGET");
                    this.columnNames = externalDataDropdown.columns.some(Boolean) ? externalDataDropdown.columns.map(column => [column.name, column.id]) : [['- select -', 'ColName']];
                    
                    widget.removeField("COLUMN");
                    widget.appendField(new Blockly.FieldDropdown(this.columnNames), 'COLUMN');
                }
            });
        }
    }
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let externalDataDropdownId = block.getFieldValue('ID');
            let columnId = block.getFieldValue('COLUMN');
            const asString = block.getFieldValue('ASSTRING');
            let code = `Snap.widgets.dynamicdropdown.getColumn('${externalDataDropdownId}', '${columnId}', ${asString})`;
            return [code, Blockly.JavaScript.ORDER_NONE];
        }
    }
}

const GetExternalDataColumn = function (props) {
    const name = 'snap_externaldata_get_column';
    GetExternalDataColumn.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return props.widgets.length ? <block type={name}></block> : null;
}

GetExternalDataColumn.propTypes = {
    context: PropTypes.object.isRequired,
    widgets: PropTypes.array.isRequired,
};

export default GetExternalDataColumn;
